exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".identification-hints .img-div{margin-right:auto;margin-left:auto;width:250px}@media (min-width:992px){.identification-hints .img-div{width:480px}}.identification-hints img{width:250px}@media (min-width:992px){.identification-hints img{width:480px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/PersonalIdentification/IdentificationHints.scss
 ** module id = 1232
 ** module chunks = 0
 **/